// extracted by mini-css-extract-plugin
export default {"container":"Saa-z","oos":"Taa-z","oosUx":"Uaa-z","selected":"Vaa-z","labelOos":"Waa-z"};